import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import './ManagerSchedule.scss'
import { withCookies, Cookies } from 'react-cookie'
import GanttChart from '../../Components/Schedule/GanttChart'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
//import 'dhtmlx-gantt';

class ManagerSchedule extends Component {
    constructor(props) {
        super(props)

        this.state = {
            position: '스케줄',
            timeline: null,
            selectMonthWorks: null,
            selectYear: new Date().getFullYear(),
            selectMonth: new Date().getMonth() + 1,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadTimeline()
        // this.loadCalendar(this.state.selectYear, this.state.selectMonth)
        history.pushState(null, document.title, location.href)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        //window.addEventListener('popstate', function(event) { history.pushState(null, document.title, location.href); });
    }

    componentWillUnmount() {
        //window.removeEventListener('popstate', function(event) { history.pushState(null, document.title, location.href); });
    }

    loadTimeline = () => {
        axios
            .get(`${BACKEND_HOST}/schedules?project_id=${this.props.cookies.get('project')}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ timeline: res.data })
                //gantt.showDate(new Date())
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadCalendar = (year, month) => {
        axios
            .get(
                `${BACKEND_HOST}/schedules/calendar/?project=${this.props.cookies.get(
                    'project'
                )}&year=${year}&month=${month}`,
                {
                    headers: {
                        Authorization: `bearer ${Auth.getToken()}`,
                    },
                }
            )
            .then((res) => {
                this.setState({ selectMonthWorks: res.data })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    calendarNext = () => {
        let newSelectYear = this.state.selectYear
        let newSelectMonth = this.state.selectMonth

        if (newSelectMonth === 12) {
            newSelectYear = newSelectYear + 1
            newSelectMonth = 1
        } else {
            newSelectMonth = newSelectMonth + 1
        }

        this.loadCalendar(newSelectYear, newSelectMonth)
        this.setState({ selectYear: newSelectYear, selectMonth: newSelectMonth })
    }

    calendarPrev = () => {
        let newSelectYear = this.state.selectYear
        let newSelectMonth = this.state.selectMonth

        if (newSelectMonth === 1) {
            newSelectYear = newSelectYear - 1
            newSelectMonth = 12
        } else {
            newSelectMonth = newSelectMonth - 1
        }

        this.loadCalendar(newSelectYear, newSelectMonth)
        this.setState({ selectYear: newSelectYear, selectMonth: newSelectMonth })
    }

    render() {
        //console.log(this.state)

        if (this.state.timeline) {
            return (
                <div>
                    <HeaderMenu />
                    <div className="section_wrap section_wrap_menu">
                        <div className="manager_schedule_wrap">
                            <ul className="schedule_btn_wrap common_wrap">
                                {/* <li
                                    onClick={() => {
                                        this.setState({ position: '스케줄' })
                                    }}
                                    className={this.state.position === '스케줄' && 'active'}>
                                    스케줄
                                </li> */}
                            </ul>
                            <div className="gantt_wrap">
                                {this.state.position === '스케줄' ? (
                                    <div className="gantt_chart">
                                        <GanttChart tasks={this.state.timeline} history={this.props.history} />
                                    </div>
                                ) : (
                                    <div className="calendar_wrap common_wrap">
                                        <div className="calen_header">
                                            <div className="calen_left_btn calen_btn" onClick={this.calendarPrev}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="7"
                                                    height="11"
                                                    viewBox="0 0 7 11">
                                                    <path
                                                        fill="none"
                                                        fillRule="evenodd"
                                                        stroke="#A2A7AE"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="1.3"
                                                        d="M6 1L1 5.5 6 10"
                                                    />
                                                </svg>
                                            </div>
                                            <div className="calen_date">
                                                {this.state.selectYear}년 {this.state.selectMonth}월
                                            </div>
                                            <div className="calen_right_btn calen_btn" onClick={this.calendarNext}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="7"
                                                    height="11"
                                                    viewBox="0 0 7 11">
                                                    <path
                                                        fill="none"
                                                        fillRule="evenodd"
                                                        stroke="#A2A7AE"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="1.3"
                                                        d="M1 1l5 4.5L1 10"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap" />
            </div>
        )
    }
}

export default withCookies(ManagerSchedule)



// WEBPACK FOOTER //
// ./Src/Containers/Schedule/ManagerSchedule.js